__turbopack_context__.v({
  "cartCountBadge": "Cart-module__do-54q__cartCountBadge",
  "cartIcon": "Cart-module__do-54q__cartIcon",
});
